import { render, staticRenderFns } from "./SpecialInputNumberField.vue?vue&type=template&id=31f2210f&"
import script from "./SpecialInputNumberField.vue?vue&type=script&lang=js&"
export * from "./SpecialInputNumberField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports